import { css } from "styled-components";
import { forPhoneOnly } from "./media-queries";

export const cssVariables = css`
  /* Colors */
  --suitBlackHSL: 219deg, 14%, 49%;
  --suitBlack: hsl(var(--suitBlackHSL));
  --secondary: var(--suitBlack);
  --secondaryMuted: hsla(var(--suitBlackHSL), 0.5);

  --suitRedHSL: 0deg, 100%, 70%;
  --suitRed: hsl(var(--suitRedHSL));
  --primary: var(--suitRed);
  --primaryMuted: hsl(var(--suitRedHSL), 0.5);

  --errorHSL: 0deg, 100%, 75%;
  --error: hsl(var(--errorHSL));
  --errorMuted: hsla(var(--errorHSL), 0.2);
  --asshole: hsl(var(--errorHSL));
  --assholeMutted: hsla(var(--errorHSL), 0.2);

  --successHSL: 145deg, 63%, 42%;
  --success: hsl(var(--successHSL));
  --successMuted: hsla(var(--successHSL), 0.2);

  --layer00HSL: 222deg, 44%, 7%;
  --layer0HSL: 222deg, 44%, 14%;
  --layer1HSL: 222deg, 44%, 16%;
  --layer2HSL: 222deg, 44%, 18%;
  --layer3HSL: 222deg, 44%, 20%;
  --backgroundHSL: var(--layer0HSL);
  --background: hsl(var(--layer0HSL));
  --foregroundHSL: var(--layer3HSL);
  --foreground: hsl(var(--layer3HSL));

  --textRGB: 255, 255, 255;
  --text: rgb(var(--textRGB));
  --textMuted: rgba(var(--textRGB), 0.8);
  --textShadow: 0 1px 1px rgba(0, 0, 0, 0.2);

  /* Fonts */
  --fontFamily: "Source Sans Pro", sans-serif;
  /* --fontFamily: 'Roboto', sans-serif; */
  --altFontFamily: "Unica One", monospace;

  --heading-size-level1: 42px;
  --heading-size-level2: 24px;

  --spacing-large: 40px;
  --spacing-default: 20px;
  --spacing-small: 10px;

  --card-width: 60px;
  --card-height: 78px;

  --bottom-control-bar-height: calc(
    var(--spacing-default) + var(--card-height) + var(--spacing-default)
  );

  --gradient-dir: 90deg;
  --fancy-primary-secondary-gradient: linear-gradient(
    var(--gradient-dir),
    hsl(0deg 100% 70%) 0%,
    hsl(350deg 89% 68%) 11%,
    hsl(340deg 73% 65%) 22%,
    hsl(330deg 55% 62%) 33%,
    hsl(316deg 37% 59%) 44%,
    hsl(294deg 25% 57%) 56%,
    hsl(270deg 23% 57%) 67%,
    hsl(247deg 19% 56%) 78%,
    hsl(229deg 17% 53%) 89%,
    hsl(218deg 14% 49%) 100%
  );
  --fancy-primary-background-gradient: linear-gradient(
    var(--gradient-dir),
    hsl(0deg 100% 70%) 0%,
    hsl(350deg 89% 68%) 11%,
    hsl(340deg 73% 65%) 22%,
    hsl(330deg 55% 62%) 33%,
    hsl(316deg 37% 59%) 44%,
    hsl(294deg 25% 57%) 56%,
    hsl(270deg 23% 57%) 67%,
    hsl(247deg 19% 56%) 78%,
    hsl(229deg 17% 53%) 89%,
    hsl(218deg 14% 49%) 100%
  );

  --fancy-primary-dual-gradient: linear-gradient(
    90deg,
    hsl(0deg 100% 70%) 0%,
    hsl(332deg 73% 67%) 10%,
    hsl(303deg 52% 63%) 20%,
    hsl(275deg 35% 59%) 30%,
    hsl(246deg 22% 54%) 40%,
    hsl(218deg 14% 49%) 50%,
    hsl(246deg 22% 54%) 60%,
    hsl(275deg 35% 59%) 70%,
    hsl(303deg 52% 63%) 80%,
    hsl(332deg 73% 67%) 90%,
    hsl(0deg 100% 70%) 100%
  );

  @media ${forPhoneOnly} {
    --card-width: 40px;
    --card-height: 52px;
    --heading-size-level1: 36px;
    --heading-size-level2: 21px;

    --spacing-large: 20px;
    --spacing-default: 10px;
    --spacing-small: 5px;
  }
`;
